import React, { Suspense, useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import genStyles from "../../generale.module.css";
import { apiCollectionState, boolModifState, collectionsCurState, idLayerEditState, localDataState, markerFormEditState, toastState, typeCollectionState, userDataState } from "../../../atoms/CollectionState";
import TooltipForm from "../../tooltipForm";
import { DropdownSelect } from "../../dropdownSelect";
import DrawService from "../../../service/DrawService";
import FileForm from "./fileForm";
import ShowService from "../../../service/showService";
import FullScreenModal from "../../modalForm/fullScreenModal";
import ReactSwitch from "react-switch";
const EditorForm = React.lazy(() => import("../../editorForm"));

export default function MarkerForm({setEntiteslist, openEntityList, deleteEntityList, objectCur, returnToEntityList, collectionName}) {
    const [form, setForm] = useRecoilState(markerFormEditState);
    const layerEdit = useRecoilValue(idLayerEditState);
    const collectioncur = useRecoilValue(collectionsCurState);
    const typeCollection = useRecoilValue(typeCollectionState);  
    const LocalData = useRecoilValue(localDataState); 
    const api_collection = useRecoilValue(apiCollectionState);
    const user_data = useRecoilValue(userDataState);  
    const setBoolModif = useSetRecoilState(boolModifState);  
    const [nomCreateur, setNomCreateur] = useState('');    
    const [nomModif, setNomModif] = useState('');    
    const [dateModif, setDateModif] = useState('');     
    const setToast = useSetRecoilState(toastState); 
    const [showEditor, setShowEditor] = useState(false);
    const [overlayTop, setOverlayTop] = useState(0);
    const [switchColor, setSwitchColor] = useState('#86d3ff');
    const headerRef = useRef(null);        
    useEffect(() => {
        if(headerRef.current){
            setOverlayTop(headerRef.current.getBoundingClientRect().bottom);
        }
    
        if(!LocalData){
            setNomCreateur(objectCur?.sogefi_nom_creation ?? 'Utilisateur inconnu');
            setNomModif(objectCur?.sogefi_nom_modification ?? 'Utilisateur inconnu');
            if (objectCur?.sogefi_date_modification) {
                setDateModif(objectCur.sogefi_date_modification);
            } 
        }
        // Récupérer la variable CSS définie dans :root
        const color = getComputedStyle(document.documentElement)
          .getPropertyValue('--main-color-first')
          .trim();
        if (color) {
            const formatcolor = ShowService.getColorFormat(color);
            switch (formatcolor) {
                case 'hex':
                    setSwitchColor(color);
                  break;
                case 'rgba':
                case 'rgb':
                    setSwitchColor(ShowService.rgbToHex(color));
                  break;
                  default : setSwitchColor('#86d3ff');
            }
          
        }
    }, []);

    const extractIconClass = (value) => {
        if (typeof value !== "string") return value;
    
        // détecte une balise <i ... class="...">
        const match = value.match(/<i[^>]*class=["']([^"']+)["'][^>]*>/i);
        if (match) {
            return match[1].trim();
        }
    
        return value;
    };
    

    const updateField = (key, newValue) => {
        let value = newValue;
        if (key === "iconClass") {
            value = extractIconClass(newValue);
        }
        setBoolModif(true);
        setForm((prev) => {
            const updatedForm = { ...prev, [key]: value };
            const updatedLayer = DrawService.updatePropertieLayer(updatedForm, layerEdit,'marker');            
            if (updatedLayer) {                
                const updatedGeoJSON = updatedLayer.toGeoJSON();                
                const updatedGeom = JSON.stringify(updatedGeoJSON.geometry);
                updatedGeoJSON.properties = updatedLayer.data;
                if(key != 'iconClass'){
                    setEntiteslist((prevList) => {
                        const updatedList = prevList.map((entity) => {
                            if (entity.id === updatedLayer.data.id) {
                                const updatedEntity = { 
                                    ...entity, 
                                    geojson: updatedGeoJSON,
                                    geom : updatedGeom,
                                    tag:updatedLayer.data.tag,
                                    titre:updatedLayer.data.titre,
                                    observation:updatedLayer.data.observation,
                                };
                                return updatedEntity;
                            }
                            return entity;
                        });
                        return updatedList;
                    });
                }
            }
            return updatedForm;
        });
    };

    // Fonction pour vérifier si une date correspond à aujourd'hui
    const isToday = (dateStr) => {
        if (!dateStr) return false;
        const date = new Date(dateStr.replace(" ", "T"));
        const today = new Date();
        return date.getDate() === today.getDate() &&
               date.getMonth() === today.getMonth() &&
               date.getFullYear() === today.getFullYear();
    };

    // Fonction pour formater une date avec "aujourd'hui" si nécessaire
    const formatDateWithToday = (dateStr) => {
        if (!dateStr) return "";
        if (isToday(dateStr)) {
            // Extraire l'heure de la date
            const date = new Date(dateStr.replace(" ", "T"));
            const heures = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            return `aujourd'hui à ${heures}h${minutes}`;
        }
        return ShowService.formatDate(dateStr);
    };

    const getEntityInfo = () => {
        if (!objectCur?.sogefi_date) return "";
        const dateCreation = formatDateWithToday(objectCur.sogefi_date);
        const isCreationToday = isToday(objectCur.sogefi_date);
        const prefixCreation = isCreationToday ? "" : "le ";
        let infoText = `Créé par ${nomCreateur} ${prefixCreation}${dateCreation}`;
        if (nomModif && dateModif) {
            const dateModifFormatted = formatDateWithToday(dateModif);
            const isModifToday = isToday(dateModif);
            const prefixModif = isModifToday ? "" : "le ";
            infoText += `\n\nDernière modification par ${nomModif} ${prefixModif}${dateModifFormatted}`;
        }
        return infoText;
    };

    const markerShapes = [
        { name: "circle", iconClass: "fa-solid fa-location-pin" },
        { name: "square", iconClass: "fa-kit fa-marker-square" },
        { name: "penta", iconClass: "fa-kit fa-marker-penta" }, // remplace par la bonne classe si tu as
        { name: "star", iconClass: "fa-kit fa-marker-star" },
    ];
    
    const defaultIcons = [
        { name: "fa fa-house", iconClass: "fa fa-house" },
        { name: "fa fa-phone", iconClass: "fa fa-phone" },
        { name: "fa fa-tag", iconClass: "fa fa-tag" },
        { name: "fa fa-plane", iconClass: "fa fa-plane" },
        { name: "fa fa-info", iconClass: "fa fa-info" },
        { name: "fa fa-bicycle", iconClass: "fa fa-bicycle" },
        { name: "fa fa-wifi", iconClass: "fa fa-wifi" },
        { name: "fa fa-briefcase", iconClass: "fa fa-briefcase" },
        { name: "fa fa-circle", iconClass: "fa fa-circle" },
        { name: "fa fa-train", iconClass: "fa fa-train" },
        { name: "fa fa-wheelchair", iconClass: "fa fa-wheelchair" },
        { name: "fa fa-traffic-light", iconClass: "fa fa-traffic-light" },
        { name: "fa fa-map", iconClass: "fa fa-map" },
        { name: "fa fa-bridge", iconClass: "fa fa-bridge" },
        { name: "fa fa-basket-shopping", iconClass: "fa fa-basket-shopping" },
        { name: "fa fa-bed", iconClass: "fa fa-bed" },
        { name: "fa fa-heart-pulse", iconClass: "fa fa-heart-pulse" },
        { name: "fa fa-do-not-enter", iconClass: "fa fa-do-not-enter" },
        { name: "fa fa-user", iconClass: "fa fa-user" }
    ];

    const presetColors = [
        { name: "#36c980", iconClass: "#36c980" },
        { name: "#a0d44f", iconClass: "#a0d44f" },
        { name: "#c9b957", iconClass: "#c9b957" },
        { name: "#face47", iconClass: "#face47" },
        { name: "#7945ca", iconClass: "#7945ca" },
        { name: "#a15bd5", iconClass: "#a15bd5" },
        { name: "#6499f4", iconClass: "#6499f4" },
        { name: "#76cbf9", iconClass: "#76cbf9" },
        { name: "#b63453", iconClass: "#b63453" },
        { name: "#db465e", iconClass: "#db465e" },
        { name: "#f61e87", iconClass: "#f61e87" },
        { name: "#f75cbf", iconClass: "#f75cbf" },
        { name: "#f7683c", iconClass: "#f7683c" },
        { name: "#f7af54", iconClass: "#f7af54" },
        { name: "#7d5247", iconClass: "#7d5247" },
        { name: "#818181", iconClass: "#818181" },
        { name: "#252525", iconClass: "#252525" },
        { name: "#FFFFFF", iconClass: "#FFFFFF" },
    ];

    // Trouver l'objet forme sélectionné (utile pour afficher l’icône dans le bouton)
    const currentShape = markerShapes.find((s) => s.name === form.markerShape) || markerShapes[0];

    const copiecoord = () => {
        if (form.latitude != null && form.longitude != null) {
          // On force les valeurs à nombre et on formate avec un point comme séparateur
          const lat = parseFloat(form.latitude).toString();
          const lng = parseFloat(form.longitude).toString();
      
          // Concaténation avec une virgule
          const coordText = `${lat},${lng}`;
      
          const textarea = document.createElement("textarea");
          textarea.value = coordText;
          document.body.appendChild(textarea);
          textarea.select();
          try {
            const successful = document.execCommand("copy");
            if (successful) {
                setToast({ message: "Coordonnées copiées dans le presse-papier" , type: 'success' }); 
            } else {
              throw new Error("Échec de la copie");
            }
          } catch (err) {
            console.error("Erreur copie coordonnée :", err);
            setToast({ message: "Impossible de copier" , type: 'error' });
          } finally {
            document.body.removeChild(textarea);
          }
        }
    };
      
    const setZoomEntity = () => {
        const geojson = objectCur?.geojson;
        ShowService.addEntitesToMap(geojson,'zoom');
    };


    return (
        <> 
        {/* Barre d'outils style Google */}
            <div className={genStyles.buttonheaderfrm} ref={headerRef}>
            {(typeCollection == 'collection' || collectioncur.edit) && (
            <>
                <TooltipForm content="Supprimer l'entité">
                    <button onClick={deleteEntityList}>
                        <i className="fa-solid fa-trash red-text text-darken-2"></i>
                    </button>
                </TooltipForm>
                <TooltipForm content={`Zoomer sur l'entité`}>
                    <button onClick={setZoomEntity}>
                        <i className="fa-solid fa-magnifying-glass-plus yellow-text text-darken-3"></i>
                    </button>
                </TooltipForm>
                <TooltipForm content={getEntityInfo()}>
                    <button>
                        <i className={`fa-solid fa-info ${genStyles.bgcolorfirsttext}`}></i>
                    </button>
                </TooltipForm>
            </>
            )}
            </div>
        
        <div className={`${genStyles.editFormContainer} scroller`}>
            <div className={genStyles.editFormSection}>
                {/* --- Info générale --- */}
                <div className={genStyles.titleedsection}>
                    <i className={`fa-solid fa-square-info ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                    Information générale
                    </span>
                </div>
                <div className={`mb10`}>
                    <span className={`${genStyles.fontSize15} black-text`}>
                    Nom de l'entité
                    </span>
                    <input
                    className={genStyles.inputtCol}
                    type="text"
                    placeholder="Donner un nom à votre entité"
                    value={form.nomEntite}
                    maxLength={50}
                    onChange={(e) => updateField("nomEntite", e.target.value)}
                    />
                </div>
                <div className={`col s12 mb10 ${genStyles.ctnswitch}`}>
                    <span className={`${genStyles.fontSize15} black-text`}>
                    Afficher le nom sur la carte
                    </span>
                    <ReactSwitch
                        onChange={(checked) => updateField("tag", checked)}
                        checked={!!form.tag}
                        onColor={switchColor}
                        offColor="#bbbbbb"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={20}
                        width={40}
                    />
                </div>
                <div className={`mb0`}>
                    <span className={`${genStyles.fontSize15} black-text`}>
                    Observation <i className={`fa-solid fa-pencil ${genStyles.fontSize16} ${genStyles.icomarginObserv}`} onClick={() => setShowEditor(true)}></i>
                    </span>
                    <div
                        className={`${genStyles.observationPreview}`}
                        dangerouslySetInnerHTML={{ __html: form.observation}}
                    />
                </div>
            </div>

            {/* --- Paramètres géographiques --- */}
            <div className={genStyles.editFormSection}>
                <div className={genStyles.titleedsection} 
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <div>
                        <i className={`fa-solid fa-location-dot ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                        <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                        Paramètres géographiques
                        </span>
                    </div>
                    <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>
                        <a onClick={copiecoord}>
                            <TooltipForm content={`Copier les coordonnées`}>
                                <i className="fa-sharp fa-solid fa-copy black-text text-darken-3" aria-hidden="true"></i>
                            </TooltipForm>
                            </a>
                    </span>
                </div>
                <div className="row mb0">
                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Latitude</span>
                        <input 
                            className={genStyles.inputtCol}
                            type="number"
                            step="0.0001"
                            value={form.latitude ?? ""}
                            onChange={(e) => updateField("latitude", parseFloat(e.target.value) || 0)}
                        />
                    </div>

                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Longitude</span>
                        <input 
                            className={genStyles.inputtCol}
                            type="number"
                            step="0.0001"
                            value={form.longitude ?? ""}
                            onChange={(e) => updateField("longitude", parseFloat(e.target.value) || 0)}
                        />
                    </div>                    
                </div>
            </div>

            {/* --- Style --- */}
            <div className={genStyles.editFormSection}>
                <div className={genStyles.titleedsection}>
                    <i className={`fa-solid fa-palette ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                    Styles
                    </span>
                </div>
                <div className="row mb10">
                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Forme du marqueur</span>
                        <div className={genStyles.pickctn}>                            
                            <DropdownSelect
                                options={markerShapes}
                                selected={currentShape.iconClass}
                                onChange={(markershape) => updateField("markerShape", markershape)}
                                type="icon"
                            />
                            <input 
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.markerShape}
                                onChange={(e) => updateField("markerShape", e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Couleur du marqueur</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.markerColor}
                                onChange={(color) => updateField("markerColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                               
                            <input 
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.markerColor}
                                onChange={(e) => updateField("markerColor", e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb0">

                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>
                            Icône  
                            <a className={`underline_hover blue-text ${genStyles.fontSize13}  ${genStyles.marginlr}`} href="https://fontawesome.com/search" target="_blank">Fontawesome</a>
                        </span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={defaultIcons}
                                selected={form.iconClass ?? ""}
                                onChange={(iconClass) => updateField("iconClass", iconClass)}
                                type="icon"
                            />
                            <input 
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.iconClass}
                                onChange={(e) => updateField("iconClass", e.target.value)}
                            />
                            <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>
                                <TooltipForm content={`Pour ajouter une nouvelle icône rendez-vous sur le site de Fontawesome.
                                        \n Sélectionnez l'icône voulue et copiez/collez le code HTML.`}>
                                    <i className="fa-sharp fa-solid fa-circle-question" aria-hidden="true"></i>
                                </TooltipForm>
                            </span>
                        </div>
                    </div>

                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Couleur de l’icône</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.iconColor}
                                onChange={(color) => updateField("iconColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                        
                            <input 
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.iconColor}
                                onChange={(e) => updateField("iconColor", e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {!LocalData && (
                <FileForm objectCur={objectCur} setEntites={setEntiteslist} />
            )}
            {(typeCollection == 'collection' || collectioncur.edit) && (
                <div className={`${genStyles.modalActions} ${genStyles.editFormFooter}`}>
                    <button
                        className={`${genStyles.modalBtn} ${genStyles.modalBtnSecondary}`}
                        onClick={returnToEntityList}
                    >
                        Annuler
                    </button>
                    <button
                        className={`${genStyles.modalBtn} ${genStyles.modalBtnPrimary}`}
                        onClick={openEntityList}
                    >
                        Enregistrer
                    </button>
                </div>
            )}

        </div>
            

        {/* Div overlay pour bloquer et griser */}
        {typeCollection === "shared" && (!collectioncur?.edit) && (
          <div className={genStyles.ctnDisabled} style={{ top: overlayTop }} />
        )}
        
        {showEditor && (
            <FullScreenModal>
                <Suspense fallback={<div>Chargement de l’éditeur...</div>}>
                    <EditorForm value={form.observation}  onChange={(html) => updateField("observation", html)} onClose={() => setShowEditor(false)} />
                </Suspense>
            </FullScreenModal>        
        )}
        </>
    );
}
